import { usePlayers, useStartSession } from '@/hooks/HostSessionControlHooks';
import AnimatedHostLobby from '../Animated/Backgrounds/AnimatedLobbyBackground';
import HostSessionFooter from '../Navigation/Footers/HostSessionFooter';
import PlayersList from '../PlayersList/PlayersList';
import { QRSection } from '../QRSection';
import OldNavMenu from '../Navigation/OldNavMenu';
import HostTips from './HostTips';
import { ArrowTipLeftIcon } from '../Icons/CommonIcons';
import { AnimatePresence, motion } from 'motion/react';
import { useState } from 'react';

export default function HostLobby({
  tipsEnabled,
  dismissableTips,
  onTipsDismissed
}: {
  tipsEnabled: boolean;
  dismissableTips: boolean;
  onTipsDismissed: () => void;
}) {
  const players = usePlayers();
  const startSession = useStartSession();
  const [gameLinkCopied, setGameLinkCopied] = useState(false);

  return (
    <div className="w-full h-full">
      <AnimatedHostLobby />
      <OldNavMenu white includeRole={false} />
      <div
        style={{
          height: 'calc(100% - 80px - 100px)',
          minHeight: 'calc(698px - 80px - 100px)'
        }}
        className="px-64 pt-24 w-full"
      >
        <div className="flex flex-row h-full">
          <div className="w-[22%] h-full flex flex-col items-start">
            <PlayersList />
          </div>
          <div className="w-[78%] h-full pb-48 flex justify-center items-center">
            <QRSection setGameLinkCopied={setGameLinkCopied} />
          </div>
        </div>
      </div>
      <HostSessionFooter>
        <div className="flex w-full justify-center">
          <AnimatePresence>
            {tipsEnabled && players.length === 0 && !gameLinkCopied && (
              <motion.div
                className="absolute w-444 -top-96"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 30 }}
              >
                <HostTips
                  text="Share your screen so others can join the game via QR code. Or share the Game link"
                  dismissable={dismissableTips}
                  onDismiss={onTipsDismissed}
                />
              </motion.div>
            )}
          </AnimatePresence>
          <AnimatePresence>
            {tipsEnabled && players.length >= 2 && (
              <motion.div
                className="absolute w-444 -top-96 flex flex-col items-end"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 30 }}
              >
                <HostTips
                  text="Once everyone’s in, press “Start the Game”. Late players can still join after."
                  dismissable={dismissableTips}
                  onDismiss={onTipsDismissed}
                />
                <ArrowTipLeftIcon className="right-32 top-103 absolute pointer-events-none" />
              </motion.div>
            )}
          </AnimatePresence>
          <button
            className="btn btn-primary btn-lg"
            disabled={players.length < 2}
            onClick={startSession}
          >
            {players.length < 2 ? 'Waiting for players...' : 'Start the Game!'}
          </button>
        </div>
      </HostSessionFooter>
    </div>
  );
}
